export enum FormDialogModeEnum {
  Create = 'create',
  Edit = 'edit',
}
